---
de:
  admin:
    production_periods:
      errors:
        generic: Produktionsperiodendaten konnten nicht geladen werden.
      filters:
        date: Datum
        month: Monat
        power_plant: Kraftwerk
        week_start: Wochenbeginn
        year: Jahr
      labels:
        data_horizon: Datengrenze
        power_plant: Kraftwerk
        settled_source: 'Abgerechnet: {source}'
        sources: Quellen
        timezone: Zeitzone
        unknown: Unbekannt
        unsettled_source: 'Nicht abgerechnet: {source}'
      missing_segments:
        empty: Keine fehlenden Segmente für die ausgewählte Ansicht.
        hours_missing:
          one: "{count} fehlende Stunde"
          other: "{count} fehlende Stunden"
        title: Fehlende Segmente
      summary:
        missing_unknown: Keine Deckungsinformation verfügbar.
        settled_hours_label: Abgerechnete Stunden vorhanden
        settled_volume_label: Abgerechnetes Volumen (MWh)
        unsettled_hours_label: Nicht abgerechnete Stunden vorhanden
        unsettled_volume_label: Nicht abgerechnetes Volumen (MWh)
      table:
        hour: Stunde
        no_day_data: Keine Stundenwerte
        no_timeline_data: Keine Zeitliniendaten
        selected_series_mwh: Ausgewählte Serie (MWh)
        settled_mwh: Abgerechnet (MWh)
        unsettled_mwh: Nicht abgerechnet (MWh)
      timeline:
        coverage: Deckung
        label: Datum
        missing_hours: Fehlende Stunden
        settled_coverage: Abgerechnete Deckung
        settled_hours: Abgerechnete Stunden
        settled_volume: Abgerechnet (MWh)
        unsettled_coverage: Nicht abgerechnete Deckung
        unsettled_hours: Nicht abgerechnete Stunden
        unsettled_volume: Nicht abgerechnet (MWh)
      title: Produktionszeiträume
